module.exports = __webpack_public_path__ + "img/3.3db72cc5.svg";